export const TOPPING_HOT_SUB = [
  {
    id: 1,
    name: "Onion",
    price: 0.99
  },
  {
    id: 2,
    name: "Mushroom",
    price: 0.99
  },
  {
    id: 3,
    name: "Green bell pepper",
    price: 0.99
  },
  { 
    id: 4,
    name: "Banana pepper",
    price: 0.99
  },
  { 
    id: 5,
    name: "Pepperoncini",
    price: 0.99
  },
  {
    id: 6,
    name: "Jalapeno",
    price: 0.99
  },
  {
    id: 7,
    name:"Extra cheese",
    price: 1.25
  },
];